// tslint:disable: max-line-length
import { checkStatus, parseJSON } from './utils';

var config = window.config;

const generateHeaders = (locale, Authorization = null) => ({
  Accept: 'application/vnd.novus+json; version=1',
  'Accept-Language': locale,
  'Content-Type': 'application/json',
  Authorization
});

export const register = (headers, b) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/auth/user/register`, {
    method: 'POST',
    headers,
    body: JSON.stringify(b)
  })
    .then(checkStatus)
    .then(parseJSON);

export const getClient = (locale, authToken, consumer) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/user/client/find?consumer=${consumer}`,
    {
      method: 'GET',
      headers: generateHeaders(locale, authToken)
    }
  )
    .then(checkStatus)
    .then(parseJSON);

export const login = (locale, clientCode, email, password) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/auth/token/create`, {
    method: 'POST',
    headers: generateHeaders(locale),
    body: JSON.stringify({
      auth_adapter: 'novus',
      consumer: clientCode,
      type: 'user',
      data: { email, password }
    })
  })
    .then(checkStatus)
    .then(parseJSON);

export const me = (locale, authToken) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/auth/me`, {
    method: 'GET',
    headers: generateHeaders(locale, authToken)
  })
    .then(checkStatus)
    .then(parseJSON);

export const getSideMenu = (locale, authToken) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/dashboard/menu`, {
    method: 'GET',
    headers: generateHeaders(locale, authToken)
  })
    .then(checkStatus)
    .then(parseJSON);

export const reset = (headers, b) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/auth/user/password/reset`, {
    method: 'POST',
    headers,
    body: JSON.stringify(b)
  })
    .then(checkStatus)
    .then(parseJSON);



// WEBPACK FOOTER //
// ./src/api/login.js